import { COLOR, histogram, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'BULLS',
  version: 1,
  label: 'Bulls Power',
  pane: 'sub',
  category: 'momentum',
  series: 'price',
  order: 270,
  inputs: [period('timeperiod', 13)],
  outputs: [histogram('bulls', 'Bulls', COLOR.green, COLOR.red)],
  talib: { functions: ['SUB', 'EMA'], expr: 'SUB(high, EMA(close, timeperiod={timeperiod}))' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
